// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiBaseUrl: 'https://netupgrade.clorentfactory.com/api/',
  //  imageBaseUrl: 'https://netupgrade.clorentfactory.com/imgs/',

  // apiBaseUrl: 'https://prod.test.clorentfactory.com/api/',
  //  imageBaseUrl: 'https://prod.test.clorentfactory.com/imgs/',


  // apiBaseUrl: 'https://localhost:44309/api/',
  //  imageBaseUrl: 'https://localhost:44309/imgs/',


  apiBaseUrl: 'https://service.clorentfactory.com/api/',
  imageBaseUrl: 'https://service.clorentfactory.com/imgs/',

  // apiBaseUrl: 'https://localhost:44309/api/',
  //  imageBaseUrl: 'https://staging.clorentfactory.com/imgs/',

  // apiBaseUrl: 'https://staging.clorentfactory.com/api/',
  // imageBaseUrl: 'https://staging.clorentfactory.com/imgs/',

};

